"use strict";

module.exports = /* @ngInject */ function(
  $q,
  $interval,
  eikonSsoService,
  eikonHeartbeatRepository,
  sideBySideApi,
  eikonUsageCheck
) {
  var that = this;
  var INTERVAL_IN_MILLISECOND = 60000;
  var sessionInvalidatedDeferred;
  var intervalPromise;

  this.reset = () => {
    sessionInvalidatedDeferred = undefined;
  };

  this.resolveWhenExistingSessionIsInvalidated = function() {
    if (!sessionInvalidatedDeferred) {
      sessionInvalidatedDeferred = $q.defer();
    }
    return eikonSsoService
      .getEikonSsoCookie()
      .then(resolveWhenSessionIsInvalidated);
  };

  function resolveWhenSessionIsInvalidated(cookies) {
    eikonUsageCheck.isUsingEikonLight().then(function(isUsingEikonLight) {
      if (isUsingEikonLight) {
        useSideBySideHeartbeat();
      } else {
        useRestBasedPollingHeartbeat(cookies);
      }
    });
    return sessionInvalidatedDeferred.promise;
  }

  function useSideBySideHeartbeat() {
    sideBySideApi.onExclusiveSignOnEvent(function() {
      if (sessionInvalidatedDeferred) {
        sessionInvalidatedDeferred.resolve();
      }
    });
  }

  function useRestBasedPollingHeartbeat(cookies) {
    intervalPromise = $interval(function() {
      isSessionValid(cookies).catch(function() {
        $interval.cancel(intervalPromise);
        if (sessionInvalidatedDeferred) {
          sessionInvalidatedDeferred.resolve();
        }
      });
    }, INTERVAL_IN_MILLISECOND);
  }

  this.stop = function() {
    if (sessionInvalidatedDeferred) {
      sessionInvalidatedDeferred.reject();
      that.reset();
    }
    $interval.cancel(intervalPromise);
  };

  function isSessionValid(cookies) {
    var eikonToken = eikonSsoService.extractEikonToken(cookies);
    return eikonHeartbeatRepository.get(eikonToken).catch(function(response) {
      if (response.status === 401) {
        return $q.reject();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./app/business/eikonSessionMonitor.js